/**
 * @author Karthik <karthik@314ecorp.com>
 * @description Initialize Faro
 */

import { BrowserConfig, browserMeta, FetchTransport, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';

import config from '../config';

const instrumentationOptions = {
	propagateTraceHeaderCorsUrls: [/api\/v1\//],
	ignoreUrls: [
		/^https:\/\/[A-Za-z0-9-]+\.api\.okjeeves\.[A-Za-z]+\/logcollect/, // faro - If ignored, fall into loop
		/^https:\/\/[A-Za-z0-9-]+\.okjeeves\.[A-Za-z]+\/_ph(?:\/.*)?$/, // posthog
		/^https:\/\/fonts\.googleapis\.com\/.*$/, // google fonts
		/^https:\/\/api\.marker\.io\/.*$/, // marker.io
		/^https:\/\/edge\.marker\.io\/.*$/, // marker.io
		/^https:\/\/s3\.eu-west-1\.amazonaws\.com\/.*$/, // marker.io - s3
	],
};

const options: BrowserConfig = {
	app: {
		name: 'Jeeves-Web',
		version: APP_VERSION,
		environment: config.environment,
	},
	transports: [
		new FetchTransport({
			url: config.faro.url,
			apiKey: config.faro.apiKey,
			bufferSize: 1000,
			concurrency: 5,
			defaultRateLimitBackoffMs: 1000,
		}),
	],
	instrumentations: [
		...getWebInstrumentations({
			captureConsole: true,
			captureConsoleDisabledLevels: [],
		}),
		new TracingInstrumentation({
			instrumentations: [new XMLHttpRequestInstrumentation(instrumentationOptions), new FetchInstrumentation(instrumentationOptions)],
		}),
	],
	metas: [browserMeta],
	beforeSend: (item) => {
		delete item.meta.sdk;
		return item;
	},
	paused: config.isLocalhost,
};

const faro = initializeFaro(options);

export default faro;
